import React from "react";
import { Link } from "react-router-dom";

const popularAirports = [
  { code: "ATL", city: "Atlanta" },
  { code: "JFK", city: "New York" },
  { code: "LAX", city: "Los Angeles" },
  { code: "MCO", city: "Orlando" },
  { code: "MIA", city: "Miami" },
  { code: "LAS", city: "Las Vegas" },
  { code: "ORD", city: "Chicago" },
  { code: "DFW", city: "Dallas" },
  { code: "DEN", city: "Denver" },
  { code: "SFO", city: "San Francisco" },
  { code: "SEA", city: "Seattle" },
  { code: "BOS", city: "Boston" },
  { code: "EWR", city: "Newark" },
  { code: "IAH", city: "Houston" },
  { code: "PHX", city: "Phoenix" },
  { code: "FLL", city: "Fort Lauderdale" },
  { code: "IAD", city: "Washington DC" },
  { code: "SAN", city: "San Diego" },
  { code: "CLT", city: "Charlotte" },
  { code: "DTW", city: "Detroit" },
];

const popularCities = [
  { city: "Miami", state: "FL" },
  { city: "Orlando", state: "FL" },
  { city: "Las Vegas", state: "NV" },
  { city: "Los Angeles", state: "CA" },
  { city: "New York", state: "NY" },
  { city: "Chicago", state: "IL" },
  { city: "Dallas", state: "TX" },
  { city: "Houston", state: "TX" },
  { city: "Atlanta", state: "GA" },
  { city: "Phoenix", state: "AZ" },
];

export default function PopularLocations() {
  return (
    <div className="mx-auto max-w-[1580px] p-4 md:p-8 space-y-8">
      {/* ================= AIRPORTS SECTION ================= */}
      <div className="rounded-xl border border-slate-200 bg-[#fbfcfd] p-5 sm:p-6 shadow-sm">
        <div className="mb-6 flex items-center gap-4">
          <div className="flex h-[46px] w-[46px] flex-shrink-0 items-center justify-center rounded-[10px] bg-[#081c3a] text-white shadow-sm">
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
                className="hidden"
              />
              {/* Airplane Icon */}
              <path d="M17.8 19.2L16 11l3.5-3.5a2.12 2.12 0 00-3-3L13 8 4.8 6.2a.5.5 0 00-.5.6l2.3 5.4L3.4 15.5l-1.9-.6a.5.5 0 00-.6.5l1 3.5 3.5 1a.5.5 0 00.5-.6l-.6-1.9 3.3-3.2 5.4 2.3a.5.5 0 00.6-.5z" />
            </svg>
          </div>
          <div>
            <h2 className="text-[19px] font-extrabold text-[#081c3a] leading-tight">
              Popular Airports
            </h2>
            <p className="text-[14px] font-medium text-[#4b6a97] mt-0.5">
              Quick airport rental locations
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {popularAirports.map((airport) => (
            <Link
              key={airport.code}
              to={`/car-rental-locations/airport-${airport.code.toLowerCase()}`}
              className="flex items-center rounded-lg border border-slate-200 bg-white px-4 py-[14px] transition-all hover:border-[#081c3a] hover:bg-slate-50 hover:shadow-sm"
            >
              <span className="font-extrabold text-[#081c3a] w-[45px]">
                {airport.code}
              </span>
              <div className="mx-3 h-5 w-px bg-slate-200"></div>
              <span className="font-semibold text-[#081c3a] truncate">
                {airport.city}
              </span>
            </Link>
          ))}
        </div>
      </div>

      {/* ================= CITIES SECTION ================= */}
      <div className="rounded-xl border border-slate-200 bg-[#fbfcfd] p-5 sm:p-6 shadow-sm">
        <div className="mb-6 flex items-center gap-4">
          <div className="flex h-[46px] w-[46px] flex-shrink-0 items-center justify-center rounded-[10px] bg-[#081c3a] text-white shadow-sm">
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </div>
          <div>
            <h2 className="text-[19px] font-extrabold text-[#081c3a] leading-tight">
              Popular Cities
            </h2>
            <p className="text-[14px] font-medium text-[#4b6a97] mt-0.5">
              Quick city rental locations
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {popularCities.map((loc) => {
            const slug = `${loc.city.toLowerCase().replace(/\s+/g, "-")}-${loc.state.toLowerCase()}`;
            return (
              <Link
                key={slug}
                to={`/car-rental-locations/city-${slug}`}
                className="flex items-center rounded-lg border border-slate-200 bg-white px-4 py-[14px] transition-all hover:border-[#081c3a] hover:bg-slate-50 hover:shadow-sm"
              >
                <span className="font-extrabold text-[#081c3a] truncate min-w-[80px]">
                  {loc.city}
                </span>
                <div className="mx-3 h-5 w-px bg-slate-200"></div>
                <span className="font-medium text-[#4b6a97]">{loc.state}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
